export default "__VITE_ASSET__CRsHPLwQ__"